import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { formatUsd } from '../../../../Utils/GenericFunctions';
import { MessageModal } from '../../../components/messageModal/MessageModal';

const BookingText = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export interface IBookingFooterProps {
  baseRent: number;
  grandTotal: number;
  securityDeposit: number;
  totalRent: number;
  termLength: number;
  canCancelReservation?: boolean;
  onCancelClick?: () => void;
  isCanceling?: boolean;
}

export const BookingFooter = ({
  baseRent,
  grandTotal,
  securityDeposit,
  termLength,
  totalRent,
  canCancelReservation = false,
  onCancelClick,
  isCanceling = false,
}: IBookingFooterProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <BookingText sx={{ marginTop: '20px' }}>
        <Typography fontWeight='bold'>Base Rent</Typography>
        <Typography>{formatUsd(baseRent)}/ 30 days</Typography>
      </BookingText>
      <BookingText sx={{ marginTop: '20px' }}>
        <Typography fontWeight='bold'>Rent for {termLength} days</Typography>
        <Typography>{formatUsd(totalRent)}</Typography>
      </BookingText>
      <BookingText>
        <Typography fontWeight='bold'>Security Deposit</Typography>
        <Typography>{formatUsd(securityDeposit)}</Typography>
      </BookingText>
      <Divider sx={{ marginTop: '20px', marginBottom: '20px' }} />
      <BookingText>
        <Typography fontWeight='bold'>Total</Typography>
        <Typography>{formatUsd(grandTotal)}</Typography>
      </BookingText>
      <BookingText>
        <Typography fontWeight='bold'>Due today</Typography>
        <Typography>{formatUsd(baseRent + securityDeposit)}</Typography>
      </BookingText>

      {canCancelReservation && (
        <Button
          variant='outlined'
          color='error'
          fullWidth
          sx={{ marginTop: '20px' }}
          onClick={() => setIsModalOpen(true)}
        >
          Cancel Reservation
        </Button>
      )}

      <MessageModal
        title='Cancel Reservation?'
        isOpen={isModalOpen}
        type='info'
        onClose={() => setIsModalOpen(false)}
      >
        <Typography>Are you sure you want to cancel this reservation?</Typography>
        <Typography sx={{ mt: 1 }}>This action cannot be undone.</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
          <Button variant='outlined' onClick={() => setIsModalOpen(false)}>
            No, Keep Reservation
          </Button>
          <Button
            variant='contained'
            color='error'
            disabled={isCanceling}
            onClick={onCancelClick}
          >
            {isCanceling ? 'Cancelling...' : 'Yes, Cancel Reservation'}
          </Button>
        </Box>
      </MessageModal>
    </>
  );
};
